import { mergeTypeDefs } from '@graphql-tools/merge';
import { sharedHostSchema } from './host/schema';
import { sharedUxpSchema } from './uxp/schema';

export const sharedSchema = mergeTypeDefs([sharedUxpSchema, sharedHostSchema]);
